import {
  ADD_SOFTWAREREPORT,
  GET_ALLSOFTWAREREPORT,
  LOADING_SOFTWAREREPORT,
  STOP_LOADING_SOFTWAREREPORT,
} from "../types";

const initialState = {
  softwareReports: [],
  total: 0,
  loading_state: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_SOFTWAREREPORT:
      // The list is refetched straight after a create, so the row order and
      // pagination stay whatever the server says — nothing to merge here.
      return state;

    case GET_ALLSOFTWAREREPORT:
      return {
        ...state,
        softwareReports: action.payload.data,
        total: action.payload.total,
      };

    case LOADING_SOFTWAREREPORT:
      return {
        ...state,
        loading_state: true,
      };

    case STOP_LOADING_SOFTWAREREPORT:
      return {
        ...state,
        loading_state: false,
      };

    default:
      return state;
  }
}
